/**
 *Angular module*/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BtnLoadingComponent} from './btn-loading/btn-loading.component';
import {FeatherIconComponent} from './feather-icon/feather-icon.component';
import {HeaderComponent} from './header/header.component';
import {
    AccountManagementComponent,
    AdminLayoutComponent,
    AgencyComponent,
    AuthorityManagementComponent,
    CustomerTabComponent,
    DashboardTabComponent,
    HRMSTabComponent,
    ProductConfigurationTabComponent,
    ReportTabComponent,
    VendingMachineTabComponent
} from './layouts/admin-layout/admin-layout.component';
import {AuthLayoutComponent} from './layouts/auth-layout/auth-layout.component';
import {BlankLayoutComponent} from './layouts/blank-layout/blank-layout.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {RouterModule} from '@angular/router';
import {SharedPipesModule} from '../pipes/shared-pipes.module';
import {SearchModule} from './search/search.module';
import {SharedDirectivesModule} from '../directives/shared-directives.module';
import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {FooterComponent} from './footer/footer.component';
import {CustomizerComponent} from './customizer/customizer.component';
import {BreadcrumbsComponent} from './breadcrumbs/breadcrumbs.component';
import {TranslateModule} from '@ngx-translate/core';
import {Ng2TelInputModule} from 'ng2-tel-input';
import {
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatNativeDateModule,
    MatOptionModule,
    MatRadioModule,
    MatSelectModule,
    MatTabsModule
} from '@angular/material';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatMultiSelectComponent} from './mat-multi-select/mat-multi-select.component';
import {DataTableSearchComponent} from './data-table-search/data-table-search.component';
import {MatterMostComponent} from './mattermost/mattermost.component';
import {SidebarCompactComponent} from './layouts/admin-layout/sidebar-compact/sidebar-compact.component';
import {IntlTelInputComponent} from './intl-tel-input/intl-tel-input.component';
import {NoRecordsComponent} from './no-records/no-records.component';
import {DataTableFilterComponent} from './data-table-filter/data-table-filter.component';
import {DatePickerComponent} from './date-picker/date-picker.component';
import {RangeDatePickerComponent} from './range-date-picker/range-date-picker.component';
import {ErrorMessageComponent} from './error-message/error-message.component';

const components = [
    BtnLoadingComponent,
    FeatherIconComponent,
    HeaderComponent,
    BreadcrumbsComponent,
    SidebarCompactComponent,
    FooterComponent,
    CustomizerComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    BlankLayoutComponent,
    MatMultiSelectComponent,
    DataTableSearchComponent,
    DashboardTabComponent,
    ProductConfigurationTabComponent,
    HRMSTabComponent,
    VendingMachineTabComponent,
    CustomerTabComponent,
    ReportTabComponent,
    AuthorityManagementComponent,
    AccountManagementComponent,
    AgencyComponent,
    MatterMostComponent,
    IntlTelInputComponent,
    NoRecordsComponent,
    DataTableFilterComponent,
    DatePickerComponent,
    RangeDatePickerComponent,
    ErrorMessageComponent
];

const entryComponents = [
    DashboardTabComponent,
    ProductConfigurationTabComponent,
    HRMSTabComponent,
    VendingMachineTabComponent,
    CustomerTabComponent,
    AuthorityManagementComponent,
    AccountManagementComponent,
    AgencyComponent,
    ReportTabComponent
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        SharedPipesModule,
        SharedDirectivesModule,
        SearchModule,
        PerfectScrollbarModule,
        TranslateModule,
        NgbModule,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatListModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSelectModule,
        MatTabsModule,
        MatOptionModule,
        MatCheckboxModule,
        MatIconModule,
        MatRadioModule,
        MatExpansionModule,
        Ng2TelInputModule
    ],
    declarations: components,
    exports: components,
    entryComponents: entryComponents
})
export class SharedComponentsModule {
}
